import { render, staticRenderFns } from "./RulesDatatable.vue?vue&type=template&id=74d1e923"
import script from "./RulesDatatable.vue?vue&type=script&lang=js"
export * from "./RulesDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports